import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  loaderExcel: false,
  saveLoading: false,
  dates: {},
  data: {},
  loadingUpdate: false,
}

export default function adminSettingsReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_ADMIN_SETTING:
      return {...state, loading: action.payload }
    case actions.LOADING_SAVE_ADMIN_SETTINGS:
      return {...state, saveLoading: action.payload }
    case actions.EXPORT_LOADER_DATA_EXCEL:
      return {...state, loaderExcel: action.payload}
    case actions.GET_ADMIN_SETTINGS:
      return {...state, dates: action.payload}
    case actions.EXPORT_DATA_TO_EXCEL:
      return {...state, data: action.payload}
    case actions.UPDATE_ADMIN_SETTINGS:
      return {...state, loadingUpdate: action.payload}
    default:
      return state
  }
}